import {
  setupReactNative,
  styled
} from "@tamagui/core";
import { focusableInputHOC } from "@tamagui/focusable";
import { TextInput } from "react-native";
import { inputSizeVariant } from "../helpers/inputHelpers";
setupReactNative({
  TextInput
});
const defaultStyles = {
  size: "$true",
  fontFamily: "$body",
  borderWidth: 1,
  outlineWidth: 0,
  color: "$color",
  focusable: true,
  borderColor: "$borderColor",
  backgroundColor: "$background",
  placeholderTextColor: "$placeholderColor",
  // this fixes a flex bug where it overflows container
  minWidth: 0,
  hoverStyle: {
    borderColor: "$borderColorHover"
  },
  focusStyle: {
    outlineColor: "$borderColorFocus",
    outlineWidth: 2,
    outlineStyle: "solid",
    borderColor: "$borderColorFocus"
  }
};
const InputFramePreTyped = styled(
  TextInput,
  {
    name: "Input",
    variants: {
      unstyled: {
        false: defaultStyles
      },
      size: {
        "...size": inputSizeVariant
      }
    },
    defaultVariants: {
      unstyled: false
    }
  },
  {
    isInput: true
  }
);
const InputFrame = InputFramePreTyped;
const Input = focusableInputHOC(InputFrame);
export {
  Input,
  InputFrame,
  defaultStyles
};
//# sourceMappingURL=Input.js.map
